import React from 'react';
import { Box, Alert, Chip } from '@mui/material';
import { MobileDeviceSection } from './MobileDeviceSection';

interface MobileResultsViewProps {
  results: any;
  weight: number | null;
  ageValue: string;
  heightInput: string;
  weightInput: string;
  heightUnit: 'cm' | 'in';
  weightUnit: 'kg' | 'lb';
  onNavigateToCalculations?: () => void;
}

export const MobileResultsView: React.FC<MobileResultsViewProps> = React.memo(({
  results,
  weight,
  ageValue,
  heightInput,
  weightInput,
  heightUnit,
  weightUnit,
  onNavigateToCalculations
}) => {
  if (!results) return null;

  return (
    <Box>
      <Alert 
        severity="warning" 
        sx={{ 
          mb: 2, 
          '& .MuiAlert-message': { fontSize: '0.9rem', textAlign: 'center' },
          borderRadius: 2
        }}
      >
        Calculations must be verified and should not replace clinical judgment in patient care.
      </Alert>
      
      <Box sx={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: 1, 
        mb: 0, 
        p: 0,
        borderRadius: 2,
        justifyContent: 'center'
      }}>
        <Chip 
          label={`Age: ${ageValue}`} 
          color="primary" 
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
        <Chip 
          label={`Category: ${results.ageCategory}`} 
          color="secondary" 
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
        {heightInput && (
          <Chip 
            label={`Height: ${heightInput} ${heightUnit}`} 
            variant="outlined"
            sx={{ fontWeight: 500 }}
          />
        )}
        {weightInput && (
          <Chip 
            label={`Weight: ${weightInput} ${weightUnit}`} 
            variant="outlined"
            sx={{ fontWeight: 500 }}
          />
        )}
        {results.ettCalculations.bmi && (
          <Chip 
            label={`BMI: ${results.ettCalculations.bmi.toFixed(1)} (${results.ettCalculations.bmiCategory})`} 
            color={results.ettCalculations.bmiCategory === 'Obese' ? 'warning' : 'default'}
            variant="outlined"
            sx={{ fontWeight: 500 }}
          />
        )}
      </Box>

      <MobileDeviceSection 
        recommendedDevices={results.recommendedDevices}
        weight={weight}
        ettCalculations={results.ettCalculations}
        onNavigateToCalculations={onNavigateToCalculations}
      />
    </Box>
  );
});